<!-- Ported from the Polaris kit: src/components/ui/textarea/Textarea.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { useVModel } from '@vueuse/core';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  defaultValue: { type: [String, Number], required: false },
  modelValue: { type: [String, Number], required: false },
});

const emits = defineEmits(['update:modelValue']);

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <textarea
    v-model="modelValue"
    data-slot="textarea"
    :class="
      cn(
        'border-polaris-input placeholder:text-polaris-muted-foreground focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 aria-invalid:ring-polaris-destructive/20 dark:aria-invalid:ring-polaris-destructive/40 aria-invalid:border-polaris-destructive dark:bg-polaris-input/30 flex [field-sizing:content] min-h-16 w-full rounded-polaris-md border border-solid bg-transparent px-3 py-2 text-base shadow transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:type-polaris-body',
        props.class
      )
    "
  />
</template>
